import { BoelsUser } from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const REQUEST_LOGIN = '[UserData] Request Login';
export const REQUEST_LOGOUT = '[UserData] Request Logout';
export const CLEAR_USER_DATA = '[UserData] Clear UserData';
export const SET_USER_DATA = '[UserData] Set UserData';
export const SET_USER_DATA_SUCCESS = '[UserData] Set UserData Success';
export const SET_USER_DATA_FAIL = '[UserData] Set UserData Failure';
export const clearUserData = createAction(CLEAR_USER_DATA);

export const requestLogin = createAction(
  REQUEST_LOGIN,
  props<{ redirectUrl?: string }>(),
);

export const requestLogout = createAction(
  REQUEST_LOGOUT,
  props<{ redirectUrl?: string }>(),
);

export const setUserData = createAction(
  SET_USER_DATA,
  props<{ user: BoelsUser }>(),
);
export const setUserDataSuccess = createAction(
  SET_USER_DATA_SUCCESS,
  props<{ user: BoelsUser }>(),
);
export const setUserDataFailure = createAction(
  SET_USER_DATA_FAIL,
  props<{ error: boolean }>(),
);
